import { IModeConfigType } from '../interfaces/auth';
import { TRANSLATIONS_AUTH } from '../translations/auth';
import type { ClientsStatus } from '../types/clients';

export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

export const SELECTED_BROKER_ID = 'selectedBrokerId';

export const LOGIN_PROVIDER_NAME = 'provider';
export const LOGIN_PROVIDER_BROKERS_PORTAL = 'brokersPortal';
export const LOGIN_PROVIDER_CREDENTIALS = 'credentials';
export const LOGIN_PROVIDER_GOOGLE = 'google';
export const LOGIN_PROVIDER_MICROSOFT = 'microsoft';

export const LOGIN_ROUTE = '/login';
export const SIGN_UP_ROUTE = '/sign-up';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const LOGIN_SSO_ROUTE = '/login-sso';

export const PROSPECTS_ROUTE = '/prospects';
export const PROSPECT_PROFILE_ROUTE = `${PROSPECTS_ROUTE}/:id`;

export const QUOTE_CREATE_ROUTE = `${PROSPECTS_ROUTE}/:prospectId/quotes/new`;
export const QUOTE_EDIT_ROUTE = `${PROSPECTS_ROUTE}/:prospectId/quotes/:quoteId/edit`;

export const CLIENTS_ROUTE = '/clients';
export const CLIENT_PROFILE_ROUTE = `${CLIENTS_ROUTE}/:id`;

export const CLIENT_PROFILE_STATUS_PARAM = 'status';

export const buildClientProfileRoute = (id: number | string, status?: ClientsStatus): string =>
  status ? `${CLIENTS_ROUTE}/${id}?${CLIENT_PROFILE_STATUS_PARAM}=${status}` : `${CLIENTS_ROUTE}/${id}`;

export const buildQuoteCreateRoute = (prospectId: number): string => `${PROSPECTS_ROUTE}/${prospectId}/quotes/new`;
export const buildQuoteEditRoute = (prospectId: number, quoteId: string | number): string =>
  `${PROSPECTS_ROUTE}/${prospectId}/quotes/${quoteId}/edit`;

export const AUTH_ROUTES: string[] = [LOGIN_ROUTE, SIGN_UP_ROUTE, RESET_PASSWORD_ROUTE, LOGIN_SSO_ROUTE];

export const BTF_DOMAIN = import.meta.env.VITE_BTF_DOMAIN;
export const SESSION_COOKIES_TIMEOUT = 1 / 24 / 2;

export const DEEPLINK_URL_PARAM = 'deeplink_url';

export const SESSION_INACTIVITY_TIMEOUT = 1000 * 60 * 30;

export const BETTERFLY_DOMAIN = '@betterfly.com';
export const GOBETTERFLY_DOMAIN = '@gobetterfly.com';

export const LOGIN_GOOGLE_PRIVACY_POLICY = 'https://policies.google.com/privacy';
export const LOGIN_GOOGLE_TERMS_AND_CONDITIONS = 'https://policies.google.com/terms';

export const ACCESS_INSTRUCTIONS_PAGE =
  'https://intercom.help/betterfly-support/es/articles/8725673-accede-por-primera-vez-al-portal-de-clientes';

export const SEND_CODE_COUNTDOWN = 120;

export const MODE_CONFIG: IModeConfigType = {
  'create-account': {
    length: 12,
    pattern: /^[a-zA-Z0-9]*$/
  },
  'password-reset': {
    length: 6,
    pattern: /^\d*$/
  },
  errorMessage: TRANSLATIONS_AUTH.verificationCode.codeInput.errorFormat
};
